import { useForm, Controller } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import styles from "./promptsAddEdit.module.css";
import { DialogContent, DialogTitle, TextField } from "@mui/material";
import { ArrowLeft, Plus, X } from "react-feather";
import { useEffect, useRef } from "react";

const schema = yup.object().shape({
  title: yup
    .string()
    .required("This field is Required")
    .max(200, "Title cannot be more than 200 characters"),
  description: yup
    .string()
    .required("This field is Required")
    .max(700, "Description cannot be more than 700 characters"),
});

const PromptAddEdit = (props) => {
  const { register, handleSubmit, control, errors, setValue, watch } = useForm({
    resolver: yupResolver(schema),
    mode: "onChange",
  });

  // Ref to track cursor position in description textarea
  const descriptionRef = useRef(null);
  const cursorPositionRef = useRef(null);

  useEffect(() => {
    if (props.promptDetails) {
      setValue("title", props.promptDetails.title);
      setValue("description", props.promptDetails.description);
    } else {
      setValue("title", "");
      setValue("description", "");
    }
  }, [props.promptDetails]);

  const onSubmit = (data) => {
    console.log(data);
    if (props.promptDetails) {
      props.updatePrompts(data);
    } else {
      props.AddPrompts(data);
    }
  };

  // Save cursor position when user clicks/types in textarea
  const handleDescriptionSelect = (e) => {
    cursorPositionRef.current = e.target.selectionStart;
    descriptionRef.current = e.target;
  };

  // Insert {{firstName}} at cursor position
  const handleInsertFirstName = () => {
    const placeholder = "{{firstName}}";
    const currentValue = watch("description") || "";

    // If we have a saved cursor position, insert there; otherwise append
    const position =
      cursorPositionRef.current !== null
        ? cursorPositionRef.current
        : currentValue.length;

    const newValue =
      currentValue.slice(0, position) +
      placeholder +
      currentValue.slice(position);

    setValue("description", newValue, { shouldValidate: true });

    // Update cursor position ref to be after the inserted placeholder
    cursorPositionRef.current = position + placeholder.length;

    // Restore focus to textarea
    setTimeout(() => {
      if (descriptionRef.current) {
        descriptionRef.current.focus();
        descriptionRef.current.setSelectionRange(
          cursorPositionRef.current,
          cursorPositionRef.current
        );
      }
    }, 0);
  };

  return (
    <>
      <DialogTitle id="alert-dialog-title" className={`${styles.CustomTitle}`}>
        <button
          className={`${styles.BackAddBU}`}
          onClick={() => props.handleAddEditForm(false)}
        >
          <ArrowLeft />
        </button>
        {props.promptDetails ? "Edit Prompt" : "Add Prompt"}
        <button
          onClick={(e) => props?.handleCloseModal(false)}
          className={`${styles.ModalCloseBU}`}
        >
          <X />
        </button>
      </DialogTitle>
      <DialogContent className={`${styles.RequestBodyPop}`}>
        <div className={`${styles.PromptAddEditSec}`}>
          <form id="myForm" onSubmit={handleSubmit(onSubmit)}>
            <div className={`${styles.FormGroup} FormGroup`}>
              <Controller
                name={`title`}
                control={control}
                render={(field) => (
                  <TextField
                    {...field}
                    label="Title*"
                    variant="outlined"
                    error={errors?.title}
                  />
                )}
              />
              {errors.title && (
                <p className={`${styles.ErrorM}`}>{errors.title.message}</p>
              )}
            </div>

            <div className={`${styles.FormGroup} FormGroup`}>
              {/* firstName insert button above textarea */}
              <div className={`${styles.PlaceholderButtonSec}`}>
                <button
                  type="button"
                  className={`${styles.PlaceholderBU}`}
                  onClick={handleInsertFirstName}
                >
                  <Plus /> First Name
                </button>
              </div>
              <Controller
                name={`description`}
                control={control}
                render={(field) => (
                  <TextField
                    {...field}
                    label="Description*"
                    variant="outlined"
                    multiline
                    rows={6}
                    error={errors?.description}
                    inputProps={{
                      onSelect: handleDescriptionSelect,
                      onClick: handleDescriptionSelect,
                      onKeyUp: handleDescriptionSelect,
                      // This gives us the actual DOM textarea element
                      ref: (el) => {
                        descriptionRef.current = el;
                      },
                    }}
                  />
                )}
              />
              {errors.description && (
                <p className={`${styles.ErrorM}`}>
                  {errors.description.message}
                </p>
              )}
            </div>

            <div className={`${styles.PromptAddEditButtonSec}`}>
              <button
                onClick={() => props.handleAddEditForm(false)}
                className={`${styles.PromptCancelBU}`}
              >
                Cancel
              </button>
              <button type="submit" className={`${styles.PromptAddBU}`}>
                {!props.promptDetails ? "Add" : "Update"}
              </button>
            </div>
          </form>
        </div>
      </DialogContent>
    </>
  );
};

export default PromptAddEdit;
